import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as saveAs from 'file-saver';
import { lastValueFrom, Subscription } from 'rxjs';
import { ActorApiClient } from 'src/app/services/api-clients/actor.api-client';
import { RequestApiClient } from 'src/app/services/request.apiclient';
import { ToastService } from 'src/app/services/toast.service';
import { DialogChangeWorkgroupComponent } from './dialogchangeworkgroup/dialogchangeworkgroup.component';
import { RequestTableComponent } from './request-table/request-table.component';
import { DashboardFilterComponent } from './dashboardfilter/dashboardfilter.component';
import { DossierService } from 'src/app/services/dossier.service';
import { LoggingService } from 'src/app/services/logging.service';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { ModalOpenerService } from 'src/app/modals/modal-opener.service';
import { AppComponent } from '../app/app.component';
import { RequestStatuses } from 'src/app/constants/status.enum';
import { WithdrawRequestModal } from 'src/app/modals/withdraw-request/withdraw-request.modal';
import { Plugin } from 'src/app/models/plugin';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { CloudLocationsService } from 'src/app/services/cloudlocations.service';
import CloudItem from 'src/app/models/clouditem';
import { RequestItemInDashboard } from 'src/app/models/dashboard';
import { PlatformHubService } from 'src/app/services/platformhub.service';

@Component({
  templateUrl: './dashboard.page.html'
})
export class DashboardPage implements OnInit, OnDestroy {
  requests: RequestItemInDashboard[] = [];
  dashboard: any[] = [];
  @ViewChild('activities') activities!: RequestTableComponent;
  @ViewChild('operation') operation!: DashboardFilterComponent;
  translations = <any>{};
  option: string | null = this.route?.snapshot?.queryParamMap?.get('option') ?? 'home';
  workgroup: boolean = true;
  anyWorkgroup: boolean = false;
  @Output('inputFromParent') inputFromParent: EventEmitter<string> = new EventEmitter();
  fullbar: string = "fullbar";
  switchbuttons: string = "switchbuttons";
  SeenIntroVersion!: string;
  renderedDocument!: any;
  plugins: Plugin[] = [];

  private hubSubscription!: Subscription;
  private dashboardDataSubscription!: Subscription;

  constructor(public platformHub: PlatformHubService, private route: ActivatedRoute, private toastService: ToastService, private translateService: TranslateService, private modalService: NgbModal,
    private requestService: RequestApiClient, private actorService: ActorApiClient, private dossierService: DossierService,
    private loggingService: LoggingService, private documentService: DocumentApiClient, private modalOpenerService: ModalOpenerService, private appComponent: AppComponent,
    private organisationApiClient: OrganisationApiClient, private cloudLocationsService: CloudLocationsService) {
    this.dashboardDataSubscription = this.platformHub.dashboardRequests$.subscribe((dashboardRequests) => {
      this.requests = dashboardRequests;
    });
    if (!platformHub.loading) {
      this.anyWorkgroup = !platformHub.requestSource.every(p => p.workgroupName == null);
      this.workgroup = new URL(window.location.href).searchParams.toString().indexOf("myrequests") == -1;
    } else {
      (platformHub.loadingobserver).subscribe({
        next: (data: boolean) => {
          if (!data) {
            this.anyWorkgroup = !platformHub.requestSource.every(p => p.workgroupName == null);
            this.workgroup = new URL(window.location.href).searchParams.toString().indexOf("myrequests") == -1;
          }
        }
      });
    }

    this.organisationApiClient.getEnabledPlugins(this.appComponent.user.organisationGuid).subscribe({
      next: (data: any) => {
        this.plugins = data;
      }
    });

    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    })
  }
  ngOnDestroy(): void {
    if (this.hubSubscription) {
      this.hubSubscription.unsubscribe();
    }
    if (this.dashboardDataSubscription) {
      this.dashboardDataSubscription.unsubscribe();
    }

  }

  getTranslations() {
    this.translateService.get([
      'Toasts.NoRequestsSelected',
      'Toasts.RequestsDownloadError',
      'Toasts.RequestsExportError',
      'Toasts.RequestsPurgeError',
      'Toasts.RequestsDeleteError',
      'Toasts.RequestsResendOne',
      'Toasts.RequestsResendMultiple',
      'Toasts.RequestsResendError',
      'Toasts.WithdrawError',
      'Toasts.MultiNotAllowedWithdrawError',
      'Toasts.Success',
      'Toasts.Error',
      'Toasts.Sent',
      'Toasts.Changed',
      'Toasts.WorkgroupRemoved',
      'Toasts.Purged',
      'Toasts.Deleted',
      'Toasts.RequestPurged',
      'Toasts.RequestDeleted',
      'Toasts.RequestOwnerChanged',
      'Toasts.DownloadTitle',
      'Toasts.DownloadBody',
      'Toasts.ExportTitle',
      'Toasts.ExportBody',
      'Toasts.RequestRestored'
    ]).subscribe(translation => {
      this.translations.toastsRequestsDownloadError = translation['Toasts.RequestsDownloadError'];
      this.translations.toastsRequestsExportError = translation['Toasts.RequestsExportError'];
      this.translations.toastsRequestsPurgeError = translation['Toasts.RequestsPurgeError'];
      this.translations.toastsRequestsDeleteError = translation['Toasts.RequestsDeleteError'];
      this.translations.toastsRequestsResendOne = translation['Toasts.RequestsResendOne'];
      this.translations.toastsRequestsResendMultiple = translation['Toasts.RequestsResendMultiple'];
      this.translations.toastsRequestsResendError = translation['Toasts.RequestsResendError'];
      this.translations.toastsWithdrawError = translation['Toasts.WithdrawError'];
      this.translations.notAllowedWithdrawError = translation['Toasts.MultiNotAllowedWithdrawError'];
      this.translations.success = translation['Toasts.Success'];
      this.translations.error = translation['Toasts.Error'];
      this.translations.noRequestsSelected = translation['Toasts.NoRequestsSelected'];
      this.translations.toastsSent = translation['Toasts.Sent'];
      this.translations.toastsChanged = translation['Toasts.Changed'];
      this.translations.toastsWorkgroupRemoved = translation['Toasts.WorkgroupRemoved'];
      this.translations.toastsPurged = translation['Toasts.Purged'];
      this.translations.toastsDeleted = translation['Toasts.Deleted'];
      this.translations.toastsRequestPurged = translation['Toasts.RequestPurged'];
      this.translations.toastsRequestDeleted = translation['Toasts.RequestDeleted'];
      this.translations.toastsRequestOwnerChanged = translation['Toasts.RequestOwnerChanged'];
      this.translations.DownloadTitle = translation['Toasts.DownloadTitle'];
      this.translations.DownloadBody = translation['Toasts.DownloadBody'];
      this.translations.ExportTitle = translation['Toasts.ExportTitle'];
      this.translations.ExportBody = translation['Toasts.ExportBody'];
      this.translations.toastsRequestRestored = translation['Toasts.RequestRestored'];
    });
  }


  ngOnInit(): void {
  }

  async performBulkAction(event: string) {
    if (!this.activities.selection || this.activities.selection.selected.length == 0) {
      return;
    }
    switch (event) {
      case "download":
        await this.downloadRequest();
        this.activities.clearSelection();
        break;
      case "export":
        await this.exportRequest();
        break;
      case "purge":
        await this.purgeRequest();
        this.activities.clearSelection();
        break;
      case "delete":
        await this.deleteRequest();
        this.activities.clearSelection();
        break;
      case "withdraw":
        this.openModalForWithdrawnRequests();
        break;
      case "change-workgroup":
        this.changeWorkgroup();
        break;
      case "send-reminder":
        this.resendRequest();
        this.activities.clearSelection();
        break;
      case "become-owner":
        await this.changeOwner();
        this.activities.clearSelection();
        break;
      case "restore":
        await this.restoreRequest();
        this.activities.clearSelection();
        break;
    }
  }

  private changeWorkgroup(): void {
    const modalRef = this.modalService.open(DialogChangeWorkgroupComponent, { centered: true, size: 'sm' });
    modalRef.componentInstance.selectedItems = this.activities.selection.selected;
    modalRef.closed.subscribe((value: string) => {
      if (value === undefined) return;

      this.showChangeWorkgroupToast(value);

      this.activities.clearSelection();
      this.anyWorkgroup = !this.platformHub.requestSource.every(p => p.workgroupName == null || p.workgroupName == "");
    });
  }

  private showChangeWorkgroupToast(value: string): void {
    const selectedCount = this.activities.selection.selected.length;
    let toastText = '';

    if (value) {
      toastText = selectedCount === 1
        ? this.translateService.instant('Toasts.WorkgroupChanged', { workgroupName: value })
        : this.translateService.instant('Toasts.WorkgroupsChanged', { workgroupName: value, amount: selectedCount });
    } else {
      toastText = selectedCount === 1
        ? this.translations.toastsWorkgroupRemoved
        : this.translateService.instant('Toasts.WorkgroupsRemoved', { amount: selectedCount });
    }

    this.toastService.showSuccess(this.translations.toastsChanged, toastText);
  }

  private async restoreRequest() {
    const selectedCount = this.activities.selection.selected.length;
    for (const item of this.activities.selection.selected) {
      await this.requestService.restoreRequest(item.requestId, item.requestName).subscribe();
    };
    this.showRestoreRequestToast(selectedCount);
  }

  private showRestoreRequestToast(selectedCount: number): void {
    let toastText = selectedCount == 1 ? this.translations.toastsRequestRestored : this.translateService.instant('Toasts.RequestsRestored', { amount: selectedCount });
    this.toastService.showSuccess(this.translations.toastsPurged, toastText);
  }

  private async downloadRequest() {
    this.toastService.showDefault(this.translations.DownloadTitle, this.translations.DownloadBody);

    await this.activities.selection.selected.forEach((item: any) => {
      (async () => {
        let index = this.platformHub.requestSource.findIndex(d => d === item);
        try {
          let downloadRequest = await this.dossierService.downloadRequest(this.platformHub.requestSource[index].requestId)
          let file = await lastValueFrom(downloadRequest);
          if (file && file.body && file.headers) {
            let filename = file.headers.get("Content-Disposition")!.replace("attachment; filename=", "");
            this.saveFile(file.body, filename);
          }
        } catch (error: any) {
          this.toastService.showError(this.translations.error, this.translations.toastsRequestsDownloadError + "");
        }
      })()
    });
  }

  private async exportRequest() {
    const modalRef = this.modalOpenerService.Open_CloudDocumentExport(this.plugins);
    modalRef.componentInstance.close.subscribe(async (event: CloudItem) => {
      if (event && event.folderId !== null && event.folderId !== undefined && event.parentId !== null && event.parentId !== undefined) {
        this.toastService.showDefault(this.translations.ExportTitle, this.translations.ExportBody);
        await this.activities.selection.selected.forEach((item: any) => {
          (async () => {
            let index = this.platformHub.requestSource.findIndex(d => d === item);
            try {
              this.cloudLocationsService.saveParentExternalContent(event.provider, event.parentId, event.folderId, this.platformHub.requestSource[index].requestId).subscribe({
                next: () => {
                },
                error: () => {
                  this.toastService.showError(this.translations.error, this.translations.toastsRequestsExportError);
                }
              })
            } catch (error: any) {
              this.toastService.showError(this.translations.error, this.translations.toastsRequestsExportError);
            }
          })()
        });
        modalRef.close();
        this.activities.clearSelection();
      } else {
        modalRef.close();
        this.activities.clearSelection();
      }
    });

  }

  private async purgeRequest() {
    for (const item of this.activities.selection.selected) {
      let index = this.platformHub.requestSource.findIndex(d => d === item);
      let previousStatus = this.platformHub.requestSource[index].status;
      this.platformHub.requestSource[index].status = "Expired";
      this.requestService.purgeRequest(item.requestId)
        .then(result => {
          lastValueFrom(result).catch(error => {
            this.loggingService.logException(error);
            this.toastService.showError(this.translations.error, this.translations.toastsRequestsPurgeError + "");
            this.platformHub.requestSource[index].status = previousStatus;
          });
        }).catch(error => {
          this.loggingService.logException(error);
          this.toastService.showError(this.translations.error, this.translations.toastsRequestsPurgeError + "");
          this.platformHub.requestSource[index].status = previousStatus;
        });
    }
    this.showPurgeRequestToast();
  }

  private showPurgeRequestToast(): void {
    const selectedCount = this.activities.selection.selected.length;
    let toastText = selectedCount == 1 ? this.translations.toastsRequestPurged : this.translateService.instant('Toasts.RequestsPurged', { amount: selectedCount });
    this.toastService.showSuccess(this.translations.toastsPurged, toastText);
  }

  private async deleteRequest() {
    if (!this.activities || !this.activities.selection || !this.activities.selection.selected) {
      return;
    }

    for (const item of this.activities.selection.selected) {
      try {
        this.requestService.deleteRequest(item.requestId).subscribe(() => {
          this.toastService.showSuccess(this.translations.success, this.translations.toastsRequestDeleted);
        });
      } catch (error: any) {
        this.loggingService.logException(error);
        this.toastService.showError(this.translations.error, this.translations.toastsRequestsDeleteError + "");
      }
    };

  }

  private resendRequest() {
    let sendReminderAllowedStatussen: string[] = RequestStatuses.ThatCanBeReminded;

    this.activities.selection.selected.forEach((item: any) => {
      this.platformHub.requestSource.findIndex(d => d === item);

      if ((item.isOwner || item.inWorkgroup) && sendReminderAllowedStatussen.includes(item.status)) {
        this.actorService.resendRequest(item.requestId, item.requestId) //2nd guid is ignored (23-04) so doesn't matter that it is double
          .then(value => {
            lastValueFrom(value)
              .then(() => {
                if (item && item.stage && RequestStatuses.ThatAreActorPending.includes(item.status)) {
                  this.showResendRequestToast(item.stage);
                } else {
                  this.showResendRequestToastNoName();
                }
              })
              .catch(error => {
                this.toastService.showError(this.translations.error, this.translations.toastsRequestsResendError + "");
                this.loggingService.logException(error);
              })
          })
          .catch(error => {
            this.toastService.showError(this.translations.error, this.translations.toastsRequestsResendError + "");
            this.loggingService.logException(error);
          });
      }
    });
  }

  private showResendRequestToast(fullName: string): void {
    let reminderSent = this.translateService.instant('Toasts.ReminderSent', {
      name: fullName
    });
    this.toastService.showSuccess(this.translations.toastsSent, reminderSent);
  }
  private showResendRequestToastNoName(): void {
    let reminderSent = this.translateService.instant('Toasts.ReminderSentNoName');
    this.toastService.showSuccess(this.translations.toastsSent, reminderSent);
  }

  private saveFile(blobContent: Blob, fileName: string) {
    const blob = new Blob([blobContent], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
  }

  updateWorkgroupVisibility(action: boolean) {
    this.workgroup = action;
  }

  public openModalForWithdrawnRequests() {
    let withdrawAllowedStatussen: string[] = RequestStatuses.ThatCanBeWithdrawn;
    let selectedRequests = this.activities?.selection?.selected;

    // need any selected requests
    if (!selectedRequests || !(selectedRequests?.length > 0)) {
      this.toastService.showWarning(this.translations.error, this.translations.noRequestsSelected);
      return;
    }

    // all requests must be allowed for withdrawal
    if (selectedRequests.filter(request => !withdrawAllowedStatussen.includes(request.status)).length > 0) {
      this.toastService.showWarning(this.translations.error, this.translations.notAllowedWithdrawError);
      return;
    }

    let requestIds = selectedRequests.map(request => request.requestId);
    const withdrawnRequestModalRef = this.modalOpenerService.Open_WithDrawnRequest(requestIds);
    (withdrawnRequestModalRef.componentInstance as WithdrawRequestModal).itemsWithdrawn.subscribe(() => {
      this.activities.clearSelection();
    });
  }

  public async changeOwner() {
    for (const activity of this.activities.selection.selected) {
      let changeOwner = await this.dossierService.ChangeOwner(activity.requestId);
      await lastValueFrom(changeOwner);
    }

    const selectedCount = this.activities.selection.selected.length;
    let toastText = selectedCount == 1 ? this.translations.toastsRequestOwnerChanged : this.translateService.instant('Toasts.RequestsOwnerChanged', { amount: selectedCount });
    this.toastService.showSuccess(this.translations.toastsChanged, toastText);
  }

}
